/**
 * useMobile.tsx
 *
 * Thin re-export over `useBreakpoint`, kept so the vendored shadcn sidebar keeps
 * its original import and stays conflict-free against future upstream updates.
 * The signature is unchanged: zero arguments, returns a boolean, 768px boundary.
 *
 * New code should import `useIsBelow` from `./useBreakpoint` directly — the
 * breakpoint is then visible at the call site instead of buried in a hook name.
 *
 * Behaviour note: this now answers correctly on the first render. The previous
 * implementation initialised to `undefined` and returned `!!undefined`, so every
 * consumer saw `false` once before the effect corrected it.
 */
export { useIsBelow, isBelowNow, BREAKPOINTS, isDesktopLayoutForced } from './useBreakpoint';
export type { Breakpoint, BreakpointOrNever } from './useBreakpoint';

import { useIsBelow } from './useBreakpoint';

export function useIsMobile(): boolean {
  return useIsBelow('md');
}
